import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { SharedWorkerPolyfill as SharedWorker } from '@okikio/sharedworker';
import { createContext, useCallback, useContext, useEffect, useRef } from 'react';
import { CHAT_SOCKET_IO_DOMAIN, SW_VERSION } from 'src/constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var ChatCharedWorkerContext = /*#__PURE__*/createContext({});

var ChatSharedWorkerProvider = function ChatSharedWorkerProvider(_ref) {
  var children = _ref.children;
  var sharedWorkerRef = useRef(null);
  useEffect(function () {
    var sharedWorker = new SharedWorker("/worker/messenger-shared-worker.global.js?socket_url=".concat(CHAT_SOCKET_IO_DOMAIN, "&v=").concat(SW_VERSION));
    sharedWorkerRef.current = sharedWorker;
    console.log('SharedWorker created');
  }, []);
  var sendMessagesToSocket = useCallback(function (message) {
    var _sharedWorkerRef$curr;

    sharedWorkerRef === null || sharedWorkerRef === void 0 ? void 0 : (_sharedWorkerRef$curr = sharedWorkerRef.current) === null || _sharedWorkerRef$curr === void 0 ? void 0 : _sharedWorkerRef$curr.port.postMessage(message);
  }, [sharedWorkerRef]);
  return /*#__PURE__*/_jsx(ChatCharedWorkerContext.Provider, {
    value: {
      sharedWorkerRef: sharedWorkerRef,
      sendMessagesToSocket: sendMessagesToSocket
    },
    children: children
  });
};

var useChatSharedWorkerProvider = function useChatSharedWorkerProvider() {
  var context = useContext(ChatCharedWorkerContext);
  return _objectSpread({}, context);
};

export { useChatSharedWorkerProvider };
export default ChatSharedWorkerProvider;